// TODO can we do something so we don't have to rely on globally defined InputMask?

export const MaskedInput = {
  name: 'mask',

  bind: function (el, binding, vnode) {
    let config = binding.value

    if (config.returnUnmasked === undefined) config.returnUnmasked = false

    function forwardComplete () {
      if (vnode.data.on.maskinput) {
        if (config.returnUnmasked) {
          vnode.data.on.maskinput(el.inputmask.unmaskedvalue())
        } else {
          vnode.data.on.maskinput(el.value)
        }
      }
    }

    config.oncomplete = forwardComplete

    window.Inputmask(config).mask(el)
  }
}

export default MaskedInput



// WEBPACK FOOTER //
// ./src/directives/MaskedInput.js